var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-chart-container"},[_c('VueApexCharts',{attrs:{"type":"area","options":_vm.options,"series":_vm.chartSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }